// Botões da conversa aberta: a barra sobre as mensagens e o que fica ao redor
// do campo de escrever.
//
// O campo de texto e o botão de enviar não entram — sem eles não há conversa.
export const BOTOES_DA_CONVERSA = [
	{ id: "filtrar", rotulo: "Filtrar mensagens", dica: "Mostra só parte das mensagens da conversa, pelo filtro escolhido." },
	{ id: "selecionar", rotulo: "Selecionar arquivos", dica: "Escolhe arquivos da conversa para baixar de uma vez." },
	{ id: "favoritas", rotulo: "Só as favoritas", dica: "Mostra só as mensagens que você marcou com estrela." },
	{ id: "buscar", rotulo: "Buscar na conversa", dica: "Procura uma palavra dentro desta conversa." },
	{ id: "emoji", rotulo: "Emoji", dica: "Abre os emojis para pôr na mensagem." },
	{ id: "anexar", rotulo: "Anexar arquivo", dica: "Envia foto, vídeo ou documento do seu computador." },
	{ id: "biblioteca", rotulo: "Enviar da biblioteca", dica: "Envia um arquivo já guardado na biblioteca da empresa." },
	{ id: "catalogo", rotulo: "Enviar catálogo", dica: "Envia produtos do catálogo da loja ao cliente." },
	// O id fica `carrinho` de propósito: trocá-lo esconderia o botão de quem
	// já personalizou a barra. Só o rótulo acompanha o vocabulário novo.
	{ id: "carrinho", rotulo: "Vendas na conversa", dica: "Monta orçamento ou pedido sem sair da conversa." },
	{ id: "agendar", rotulo: "Agendar envio", dica: "Escreve agora e escolhe dia e hora para a mensagem sair." },
	{ id: "assinar", rotulo: "Chave de assinar", dica: "Liga ou desliga seu nome no topo de cada mensagem enviada." },
	{ id: "iaCorrigir", rotulo: "Corrigir e sugerir com IA", dica: "A IA corrige o texto e sugere respostas antes de enviar." },
	{ id: "audio", rotulo: "Gravar áudio", dica: "Grava e envia uma mensagem de voz." },
];

// Ids acrescentados depois que esta preferência já existia. Ver
// `comNovos` (services/prefsTickets.js): sem isto o botão nasce escondido para quem já personalizou
// a barra, sem ninguém ter escolhido escondê-lo.
export const BOTOES_NOVOS = ["carrinho", "agendar"];

export const IDS_BOTOES_DA_CONVERSA = BOTOES_DA_CONVERSA.map((b) => b.id);
